import { DEFAULT_PREFERENCES, usePreferencesStore } from "#src/store/preferences";
import { isDarkTheme } from "#src/utils/is-dark-theme";
import { isLightTheme } from "#src/utils/is-light-theme";
import { useMemo } from "react";

/**
 * Wraps user preference parameters. These do not need to be stored in localStorage,
 * but are included here as convenient variables for easier use.
 *
 * @returns An object containing user preferences, including theme, whether it is the default setting,
 * and whether it is a dark or light theme.
 */
export function usePreferences() {
	const preferences = usePreferencesStore();
	const { theme } = preferences;

	// Checks if the current preferences are the default user preferences
	const isDefault = useMemo(() => {
		return Object.entries(DEFAULT_PREFERENCES).every(([key, value]) => {
			return preferences[key as keyof typeof preferences] === value;
		});
	}, [preferences]);

	return {
		...preferences,
		isDefault,
		isDark: isDarkTheme(theme),
		isLight: isLightTheme(theme),
	};
}
